<template>
    <div class="table-container">
        <nav class="level">
            <!-- Left side -->
            <div class="level-left"></div>

            <!-- Right side -->
            <div class="level-right">
                <div class="level-item">
                    <app-search-bar
                        v-model="searchValue"
                        class="lb-media-search-bar"
                    />
                </div>
            </div>
        </nav>

        <table class="table is-fullwidth is-bordered">
            <thead>
                <tr>
                    <th>{{ $t('Sessions.player-name') }}</th>
                    <th class="has-text-centered">
                        {{ $t('Sessions.score') }}
                    </th>
                    <th class="has-text-centered">{{ $t('Sessions.time') }}</th>
                    <th class="has-text-centered">
                        {{ $t('Sessions.hit_rate') }}
                    </th>
                    <th class="has-text-centered">
                        {{ $t('Sessions.mean_time') }}
                    </th>
                    <th class="has-text-centered">
                        {{ $t('Sessions.last_played_date') }}
                    </th>
                    <th class="has-text-centered">
                        {{ $t('Sessions.device') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="player in filteredRanking"
                    :key="player.owner._id"
                    :class="{ unplayed: !hasplayed(player) }"
                    class="player-data"
                    @click="showPlayerStats(player)"
                >
                    <td class="subtitle is-6 has-text-align-left is-vcentered">
                        <user-mini-profile :user="player" :show-school="true" />
                        <!--<p class="has-text-weight-bold">{{ player.alias || player.name }}</p>
                        <p v-if="player.school">{{ player.school.name }}</p>-->
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span v-html="hasplayed(player) ? player.score : '-'" />
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.totalTime(player.time)
                                    : '-'
                            "
                        />
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerHitRate(player)
                                    : '-'
                            "
                        />
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerMeanTime(player)
                                    : '-'
                            "
                        />
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerPlayDate(
                                          player.timesPlayed
                                      )
                                    : '-'
                            "
                        />
                    </td>
                    <td
                        class="
                            title
                            has-text-weight-bold
                            is-5
                            has-text-primary has-text-centered
                            is-vcentered
                        "
                    >
                        <span
                            v-html="hasplayed(player) ? player.device : '-'"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <session-detail-player
            v-if="showPlayerDetails"
            :player="player"
            :report-info="reportInfo"
            @close="showPlayerDetails = false"
        />
    </div>
</template>

<script>
import UserMiniProfile from '@/components/UserMiniProfile';
import SessionDetailPlayer from '@/components/SessionDetailPlayer';
import AppSearchBar from '@/components/AppSearchBar';
import { groupBy, reduce, findWhere, map, sortBy } from 'underscore';
import { getSessionRankingStatistics, getSessionRanking } from '@/services/API';
import { timeFormat } from '@/lib/helpers';
import moment from 'moment';
import { Document } from 'flexsearch';
import _ from 'underscore';
export default {
    name: 'SessionDetailPlayers',
    components: {
        UserMiniProfile,
        AppSearchBar,
        SessionDetailPlayer,
    },
    filters: {
        playerHitRate(player) {
            if (player.answersCount)
                return (
                    (player.score / player.answersCount / 10) *
                    100
                ).toFixed(0);
            else {
                return 0;
            }
        },
        playerMeanTime(player) {
            return timeFormat(player.meanTime || 0) + ' min';
        },
        totalTime(time) {
            return timeFormat(+time) + ' min';
        },
        playerPlayDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    props: {
        questions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        clues: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isTreasurehunt: {
            type: Boolean,
            default: false,
        },
        /*userAnswers: {
            type: Array,
            default: () => {
                return [];
            },
        },*/
        content: {
            type: Array,
            default: () => {
                return [];
            },
        },
        reportInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            ranking: {},
            searchValue: null,
            searchIndex: null,
            player: {},
            showPlayerDetails: false,
            position: null,
        };
    },
    computed: {
        uniquePlayers() {
            let players = groupBy(this.scores, (score) => {
                return score.owner.owner;
            });
            let ranking = map(players, (scores, player) => {
                return {
                    name: scores[0].owner.name,
                    owner: scores[0].owner.owner,
                    score: reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.points;
                        },
                        0
                    ),
                    time: reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.time;
                        },
                        0
                    ),
                };
            });
            return sortBy(ranking, 'totalScore').reverse();
        },
        filteredRanking() {
            if (this.searchValue) {
                let items;
                items = this.ranking;
                this.searchIndex.remove(this.ranking);
                this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.ranking.filter((item) => {
                    return _.contains(ids, item._id);
                });

                //return this.searchIndex.search(this.searchValue);
            }
            return this.ranking;
        },
    },
    mounted() {
        getSessionRankingStatistics(this.$route.params._id).then(({ data }) => {
            this.ranking = data;
        });
    },
    methods: {
        hasplayed(player) {
            return player.time != '0';
        },
        showPlayerStats(player) {
            let playerData = { ...player };
            playerData.position = this.ranking.indexOf(player) + 1;
            playerData.playedDate = this.$options.filters.playerPlayDate(
                playerData.timesPlayed
            );
            playerData.hitRate = Number(
                this.$options.filters.playerHitRate(playerData)
            );
            playerData.score = Number(playerData.score);
            playerData.gameTime = this.$options.filters.totalTime(
                playerData.time
            );
            playerData.meanTime =
                this.$options.filters.playerMeanTime(playerData);

            playerData.clues = [...this.clues];
            playerData.questions = [...this.questions];
            this.player = playerData;
            this.showPlayerDetails = true;
        },
    },
    beforeMount() {
        this.searchIndex = new Document({
            resolution: 3,
            tokenize: 'full',
            document: {
                id: '_id',
                index: ['alias', 'username', 'school.name'],
            },
        });
    },
    watch: {
        ranking() {
            this.ranking.forEach((item) => {
                this.searchIndex.add(item);
            });
        },
    },
};
</script>

<style scooped>
.lb-mini-profile-title {
    color: #4a4a4a !important;
}
.lb-project-search-bar {
    background-color: transparent;
    border: none;
    max-width: 100px;
}
.lb-project-search-bar .icon {
    color: #4a4a4a !important;
}
.lb-project-search-bar input {
    color: #4a4a4a !important;
}
::-webkit-input-placeholder {
    /* Chrome */
    color: #4a4a4a !important;
}
:-ms-input-placeholder {
    /* IE 10+ */
    color: #4a4a4a !important;
}
::-moz-placeholder {
    /* Firefox 19+ */
    color: #4a4a4a !important;
    opacity: 1;
}
:-moz-placeholder {
    /* Firefox 4 - 18 */
    color: #4a4a4a !important;
    opacity: 1;
}
.unplayed {
    display: none;
}
.player-data {
    cursor: pointer;
}
</style>
